import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import nextIcon from "../icons/chevron-right.svg";
import prevIcon from "../icons/chevron-left.svg";
import ChevronUpIcon from "../icons/chevron-up.svg";
import ChevronDownIcon from "../icons/chevron-down.svg";

const PageScroller = ({
  pageNumber,
  totalPages,
  pageSize,
  onPageChange,
  onPageSizeChange,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { t } = useTranslation();
  const dropdownRef = useRef(null);

  const handlePageChange = (page) => {
    if (page >= 0 && page < totalPages) {
      onPageChange(page);
    }
  };

  const generatePageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 0; i < totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (pageNumber <= 2) {
        pages.push(0, 1, 2, 3, "...", totalPages - 1);
      } else if (pageNumber >= totalPages - 3) {
        pages.push(0, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1);
      } else {
        pages.push(0, "...", pageNumber - 1, pageNumber, pageNumber + 1, "...", totalPages - 1);
      }
    }
    return pages;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const pageNumbers = generatePageNumbers();

  return (
    <div className="flex items-center justify-between py-4">
      <div className="flex items-center gap-3">
        <button
          className={`w-[32px] h-[32px] flex items-center justify-center bg-white shadow-[0px_20px_80px_rgba(0,0,0,0.07)] rounded-lg ${pageNumber === 0 ? "text-[#38485C] cursor-not-allowed" : "hover:text-[#6B78F8]"
            }`}
          onClick={() => handlePageChange(pageNumber - 1)}
          disabled={pageNumber === 0}
        >
          <img src={prevIcon} alt="Previous" className="w-4 h-4" />
          </button>

        <div className="flex items-center gap-2">
          {pageNumbers.map((page, index) =>
            typeof page === "number" ? (
              <button
                key={index}
                className={`w-[32px] h-[32px] text-[14px] flex items-center justify-center shadow-[0px_20px_80px_rgba(0,0,0,0.07)] rounded-lg ${page === pageNumber
                  ? "bg-[#6A78F8] text-white"
                  : "bg-white text-gray-600 hover:text-blue-500"
                  }`}
                onClick={() => handlePageChange(page)}
              >
                {page + 1}
              </button>
            ) : (
              <span key={index} className="text-[#38485C]">...</span>
            )
          )}
        </div>

        <button
          className={`w-[32px] h-[32px] flex items-center justify-center bg-white shadow-[0px_20px_80px_rgba(0,0,0,0.07)] rounded-lg ${pageNumber >= totalPages - 1 ? "text-gray-300 cursor-not-allowed" : "hover:text-blue-500"
            }`}
          onClick={() => handlePageChange(pageNumber + 1)}
          disabled={pageNumber >= totalPages - 1}
        >
          <img src={nextIcon} alt="Next" className="w-4 h-4" />
          </button>
      </div>

        <div className="flex items-center relative" ref={dropdownRef}>
        <h3 className="mr-2 font-medium text-[14px] text-[#38485C]">
          {t(`placeholder.show_rows`)}
        </h3>
        <div className="relative w-[72px]">
          <button
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className="w-full h-[32px] text-center text-[14px] bg-white border border-gray-300 rounded-lg shadow-[0px_20px_80px_rgba(0,0,0,0.07)] flex items-center justify-between px-2"
          >
            {pageSize}
            <img
              src={isDropdownOpen ? ChevronUpIcon : ChevronDownIcon}
              alt="Dropdown Icon"
              className="w-4 h-4"
            />
          </button>

          {isDropdownOpen && (
            <div className="absolute z-10 bottom-full right-0 mb-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg">
              {[10, 20, 30, 50, 100].map((size, index) => (
                <div key={size}>
                  <button
                    className={`block w-full px-2 py-1 text-center hover:bg-gray-100 ${size === pageSize ? "text-[#6A78F8] font-bold" : "text-[#38485C]"}`}
                    onClick={() => {
                      onPageSizeChange(size);
                      setIsDropdownOpen(false);
                    }}
                  >
                    {size}
                  </button>
                  {index < 4 && (
                    <div className="w-[80%] h-[1px] bg-[#F7F7F7] mx-auto"></div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageScroller;
